import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrievePrimaryMenu } from "../../redux/slice/primary-menu-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import DropdownMenu from "./dropdown-menu";

const SecondaryNav = () => {
  const { data } = useSelector((state: RootState) => state.primaryMenu)

  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(retrievePrimaryMenu())
  }, [dispatch])

  if (data) {
    return <>
      <div className="container">
        <div className="themenu text-center d-flex">
          {
            data.map((menuItemdata) => {
              return menuItemdata.data.map((menuItem, index) => {
                return menuItem.childrens.map((item, index) => {
                  const mit = { menuIt: item.childrens }
                  return <div className={`menu-item topic col-md ${item.name.toLowerCase()}`} key={index}>
                    <div className="menu-title">
                      <h3 key={index}>{item.name} <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow"></i></h3>
                    </div>
                    <DropdownMenu mits={item.childrens} />
                  </div>
                })
              })
            })
          }
        </div>
      </div>
    </>
  }

  return null;
}

export default SecondaryNav;